export const blockIconsCommonactionsTranslateNew = (
	<span className='material-symbols-outlined'>translate</span>
);
